import { Icon } from '@/src/components/ui';
import { ADD_CONTENT_BUTTONS } from '@/src/constants/constants';
import { useBoolean } from '@/src/hooks/use-boolean';
import { useClickOrDrag } from '../../hooks/useClickOrDrag';
import { IUITile } from '@/src/types/ITile';
import { cn } from '@workspace/ui/lib/utils';

type AddContentButtonProps = {
  addButton: (type: IUITile['type']) => void;
  isMyProfile: boolean;
};

export const AddContentButton = ({
  addButton,
  isMyProfile,
}: AddContentButtonProps) => {
  const isManyButtons = useBoolean(false);

  const handleClick = (
    e: React.MouseEvent<HTMLButtonElement> | React.TouchEvent<HTMLButtonElement>
  ) => {
    e.stopPropagation();
    const type = e.currentTarget.getAttribute('data-type');
    if (type) {
      addButton(type as IUITile['type']);
    }
  };

  const { onMouseDown, onTouchStart } = useClickOrDrag(() => {
    isManyButtons.onToggle();
  });

  return (
    <div className={cn('flex items-center justify-center w-full h-full', {})}>
      {isManyButtons.value ? (
        <div className="grid grid-cols-2 gap-1 my-2">
          {ADD_CONTENT_BUTTONS.map((button) => (
            <button
              data-type={button.type}
              key={button.type}
              className="flex items-center justify-center md:rounded-xl rounded-[8px] hover:bg-gray-900 hover:text-white bg-bg-gray text-black w-full transition-all duration-500 ease-in-out cursor-pointer md:py-3 md:px-5 px-4 py-1.5"
              onMouseDown={handleClick}
              onTouchStart={handleClick}
            >
              <div className="flex items-center w-full flex-col">
                <Icon name={button.icon} className="size-4" />
                <span className="md:text-sm text-xs font-medium md:pt-1">
                  {button.title}
                </span>
              </div>
            </button>
          ))}
          <button
            className="flex items-center justify-center rounded-[8px] hover:bg-gray-900 hover:text-white bg-bg-gray text-black col-span-2 transition-all duration-500 ease-in-out cursor-pointer"
            data-type="add-title"
            onMouseDown={handleClick}
            onTouchStart={handleClick}
          >
            <div className="flex items-center justify-between md:py-2 py-1.5 md:px-4 px-3 md:gap-7 gap-2 w-full">
              <Icon name="title" className="size-4" />
              <span className="md:text-sm text-xs font-medium">
                Section title
              </span>
            </div>
          </button>
        </div>
      ) : (
        <div
          className="flex flex-col items-center justify-center w-full h-full transition-colors cursor-pointer text-gray-text rounded-xl"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onMouseDown(e);
          }}
          onTouchStart={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onTouchStart(e);
          }}
        >
          <div className="flex items-center justify-center p-2 border border-gray-200 bg-gray-100 rounded">
            <Icon name="add-content" className="size-4 text-black" />
          </div>
          <p className="mt-3 text-sm font-medium">Add to page...</p>
        </div>
      )}
    </div>
  );
};
